import ExpoEsimManagerModule from "./ExpoEsimManagerModule";

export type {
  EsimInstallResult,
  EsimInstallError,
  EsimInfo,
} from "./ExpoEsimManagerModule";

export {
  useEsimManager,
  InstallationStatus,
  InstallError,
} from "./useEsimManager";

export function isEsimSupported() {
  return ExpoEsimManagerModule.isEsimSupported();
}

export function getInstalledEsims() {
  return ExpoEsimManagerModule.getInstalledEsims();
}

export function diagnosticInfo() {
  return ExpoEsimManagerModule.diagnosticInfo();
}

export function install(params: { activationCode: string }) {
  return ExpoEsimManagerModule.install(params);
}

export function scanQrCode() {
  return ExpoEsimManagerModule.scanQrCode();
}
